/* Je Moeder — Theme JS */

(function () {
  'use strict';

  /* --- Sticky Header Scroll State --- */
  const header = document.querySelector('.site-header');
  if (header) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          header.classList.toggle('is-scrolled', window.scrollY > 10);
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  /* --- Mobile Menu --- */
  const menuToggle = document.querySelector('.header-menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');

  if (menuToggle && mobileNav) {
    // Create overlay
    const overlay = document.createElement('div');
    overlay.className = 'mobile-nav-overlay';
    document.body.appendChild(overlay);

    function openMenu() {
      mobileNav.classList.add('is-open');
      menuToggle.classList.add('is-open');
      overlay.classList.add('is-open');
      if (header) header.classList.add('menu-open');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      mobileNav.classList.remove('is-open');
      menuToggle.classList.remove('is-open');
      overlay.classList.remove('is-open');
      if (header) header.classList.remove('menu-open');
      document.body.style.overflow = '';
    }

    menuToggle.addEventListener('click', () => {
      if (mobileNav.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    overlay.addEventListener('click', closeMenu);

    if (mobileClose) {
      mobileClose.addEventListener('click', closeMenu);
    }

    mobileNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });
  }

  /* --- Quantity Selector --- */
  const isCartPage = !!document.querySelector('.cart-page');

  function updateCartItem(input) {
    const cartItem = input.closest('.cart-item');
    if (!cartItem) return;
    const key = cartItem.querySelector('.cart-item__remove')?.href;
    if (!key) return;
    const idMatch = key.match(/[?&]id=([^&]+)/);
    if (!idMatch) return;

    const quantity = parseInt(input.value, 10);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: idMatch[1], quantity: quantity }),
    })
      .then((r) => r.json())
      .then((cart) => {
        // Update line total for this item
        const item = cart.items.find((i) => String(i.key) === idMatch[1]);
        const lineTotal = cartItem.querySelector('.cart-item__total');
        if (item && lineTotal) {
          lineTotal.textContent = formatMoney(item.final_line_price);
        }
        // If quantity is 0, remove the row
        if (!item || quantity === 0) {
          cartItem.remove();
        }
        // Update summary
        const summaryRows = document.querySelectorAll('.cart-summary__row');
        summaryRows.forEach((row) => {
          const label = row.querySelector('span:first-child');
          const value = row.querySelector('span:last-child');
          if (label && value) {
            if (label.textContent.trim() === 'Subtotaal' || label.textContent.trim() === 'Totaal') {
              value.textContent = formatMoney(cart.total_price);
            }
          }
        });
        // Update item count
        const countEl = document.querySelector('.cart-page__count');
        if (countEl) {
          countEl.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');
        }
        // If cart is empty, reload to show empty state
        if (cart.item_count === 0) {
          window.location.reload();
        }
      });
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  document.querySelectorAll('.quantity-selector').forEach((selector) => {
    const input = selector.querySelector('input');
    const minus = selector.querySelector('[data-action="decrease"]');
    const plus = selector.querySelector('[data-action="increase"]');

    if (!input) return;

    minus?.addEventListener('click', () => {
      const val = parseInt(input.value, 10);
      if (val > 1) {
        input.value = val - 1;
        if (isCartPage) updateCartItem(input);
      }
    });

    plus?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
      if (isCartPage) updateCartItem(input);
    });

    if (isCartPage) {
      input.addEventListener('change', () => updateCartItem(input));
    }
  });

  /* --- Add to Cart — all buy buttons --- */
  document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantId = window.siteVariantId;
      if (!variantId) {
        window.location.href = '/#bestel';
        return;
      }
      const originalText = btn.textContent;
      btn.textContent = 'Toegevoegd!';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((res) => {
          if (res.ok) {
            setTimeout(() => {
              window.location.href = '/cart';
            }, 600);
          } else {
            btn.textContent = originalText;
            btn.disabled = false;
          }
        })
        .catch(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  });

  /* --- Quote Scroll Reveal --- */
  const revealBlock = document.querySelector('[data-scroll-reveal]');
  if (revealBlock) {
    const words = revealBlock.querySelectorAll('.reveal-word');
    const updateWords = () => {
      const blockRect = revealBlock.getBoundingClientRect();
      const viewH = window.innerHeight;
      // progress 0→1 as the block scrolls from bottom of viewport to 30% from top
      const start = viewH;
      const end = viewH * 0.3;
      const progress = Math.min(1, Math.max(0, (start - blockRect.top) / (start - end)));
      const revealCount = Math.floor(progress * words.length);
      words.forEach((w, i) => {
        w.classList.toggle('is-visible', i < revealCount);
      });
    };
    let revealTicking = false;
    window.addEventListener('scroll', () => {
      if (!revealTicking) {
        window.requestAnimationFrame(() => {
          updateWords();
          revealTicking = false;
        });
        revealTicking = true;
      }
    });
    updateWords();
  }

  /* --- Parallax Effect for Quote Collage Images --- */
  const parallaxItems = document.querySelectorAll('.parallax-img');
  if (parallaxItems.length) {
    const updateParallax = () => {
      const viewH = window.innerHeight;
      parallaxItems.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        // -1 when element center is at bottom of viewport, +1 at top
        const progress = (viewH / 2 - center) / (viewH / 2);
        const speed = parseFloat(el.dataset.parallaxSpeed) || 0.1;
        const offset = progress * speed * viewH;
        // Read existing inline transform to preserve rotate + translate
        const base = el.style.transform.replace(/translateY\([^)]*\)/, '').trim();
        el.style.transform = base + ' translateY(' + offset + 'px)';
      });
    };
    let parallaxTicking = false;
    window.addEventListener('scroll', () => {
      if (!parallaxTicking) {
        window.requestAnimationFrame(() => {
          updateParallax();
          parallaxTicking = false;
        });
        parallaxTicking = true;
      }
    });
    updateParallax();
  }

  /* --- Smooth Scroll for Anchor Links --- */
  document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      const href = anchor.getAttribute('href');
      const hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;
      const hash = href.slice(hashIndex);
      const path = href.slice(0, hashIndex);
      // Only smooth-scroll if we're on the same page (or path is "/" and we're home)
      const isHome = window.location.pathname === '/' || window.location.pathname === '';
      const samePage = path === '' || path === '/' || path === window.location.pathname;
      if (samePage && isHome) {
        const target = document.querySelector(hash);
        if (target) {
          e.preventDefault();
          const headerHeight =
            document.querySelector('.site-header')?.offsetHeight || 0;
          const top =
            target.getBoundingClientRect().top + window.scrollY - headerHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }
      // Otherwise, let the browser navigate to /#section normally
    });
  });
})();
